import { call, put, takeLatest , select } from 'redux-saga/effects';
import ApiRouts from '../../api/routes';
import {GET} from "../../api";
import {
     FETCH_COLOR_LIST,
     SET_COLOR_LIST
} from "../actions";




export function* FetchColorListSaga() {


    try {

        const response = yield call(GET, `${ApiRouts.API_COLOR_LIST}` , {});

        if (response) {

            yield put({
                type:SET_COLOR_LIST,
                payload:response.data.data
            });
        } else {
            throw new Error('Failed to fetch the latest version');
        }

    } catch (error) {
        // yield put(setError(error.message));  // Set error if something goes wrong
        // yield put(setLoading(false));  // End loading in case of error
    }
}

// Watcher Saga
function* colorListSaga() {
    yield takeLatest(FETCH_COLOR_LIST, FetchColorListSaga);
    // yield takeLatest(SET_LATEST_VERSION, setLatestVersion);
}

export default colorListSaga;
